import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressTabs from '../components/ProgressTabs';
import SweatTextTitle from '../steps/SweatTextTitle';
import RemindersInfo from './RemindersInfo';
import '../BasicReminder.css';
import { getBackendURL } from '../utils';
import { useAuth } from '../auth';

const StepNextAppointment = () => {
  const [day, setDay] = useState('');
  const [time, setTime] = useState('10:00');
  const [client, setClient] = useState(null);
  const navigate = useNavigate();
  const { user, fetchUserInfo} = useAuth();

  React.useEffect(() => {
    fetchUserInfo(); // Refresh user info to get the latest client data
  }, []);

  React.useEffect(() => {
    setClient(user?.trainer_info?.clients?.[0] || null);
  }, [user]);

  const handleNext = async () => {
    if (!client || !day || !time) return;
    try {
      await fetch(getBackendURL() + `/client/${client.id}`,
        {
          method: 'PUT',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${window.localStorage.getItem('ptc_access_token') || ''}`
          },
          body: JSON.stringify({ [`timeslot_${day}`]: time })
        }
      );
      navigate('/tools/reminders/stepinviteclient');
    } catch (err) {
      alert('Failed to update appointment.');
    }
  };

  const dayOptions = [
    { value: '', label: 'Select a weekday...' },
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
    { value: 'sunday', label: 'Sunday' },
  ];

  // If no user redirect to homepage.
  if (!user) {
    return (
      <div className="reminder-container fogged-card">
        Sorry, you must be logged in to access this page.
      </div>
    );
  } 
  return (
    <div className="reminder-container fogged-card">
      <SweatTextTitle />
      <RemindersInfo />
      <ProgressTabs currentStep={5} />
      <h2 className="step-title">Step 6: When is your next appointment with {client ? client.pre_user_name : 'your client'}?</h2>
      <div style={{ margin: '1.5rem 0', maxWidth: '400px' }}>
      <p>This will all be editable in the dashboard later.</p>
        <label style={{ display: 'block', marginBottom: '0.75rem', fontWeight: 'bold' }}>Day:</label>
        <select
          value={day}
          onChange={e => setDay(e.target.value)}
          style={{ padding: '0.75rem 1rem', fontSize: '1rem', width: '100%', borderRadius: '6px', border: '1px solid #ccc', marginBottom: '1.5rem' }}
        >
          {dayOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        <label style={{ display: 'block', marginBottom: '0.75rem', fontWeight: 'bold' }}>Time:</label>
        <input
          type="time"
          value={time}
          onChange={e => setTime(e.target.value)}
          style={{ padding: '0.75rem 1rem', fontSize: '1rem', width: '100%', borderRadius: '6px', border: '1px solid #ccc' }}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
        <button
          className="ptc-secondary-button"
          style={{ padding: '1rem 2rem', fontSize: '1rem', background: '#ccc', color: '#222', border: 'none' }}
          onClick={() => navigate('/tools/reminders/stepclientname')}
        >
          Previous Step
        </button>
        <button
          className="ptc-button"

          style={{ padding: '1rem 2rem', 
            background: day && time && client ? '#6610f2' : '#ccc', 
            color: day && time && client ? 'white' : '#222', 
            border: 'none', 
            cursor: day && time && client ? 'pointer' : 'not-allowed',
            fontSize: '1rem' }}
          onClick={handleNext}
          disabled={!day || !time || !client}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default StepNextAppointment;
